import React, { useState, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { memberships } from "variables/markets";
import { membershipStatusData, membershipStatusDataNoAdmin } from "variables/lists/markets";
import { putMarketMembership} from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function EditMarketMembershipStatusDialog(props) {
  const { closeModal, refetch, membership } = props;
  const appContext = useContext(MarketsContext);
  const { market } = appContext;
  const [status, setStatus] = useState(membership.parameters.status);
  const [datemembership, setDatemembership] = useState(membership.parameters.datemembership);
  const [dateend, setDateend] = useState(membership.parameters.dateend);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = async (event) => {
    updateMarketMembership(event);
  };

  const handleStatusChange = (event) => { setStatus(event.target.value); };
  const handleDatemembershipChange = (event) => { setDatemembership(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };


  const updateMarketMembership = async (event) => {
    await axios
      .put(
        putMarketMembership(membership.id),
        {
          ...membership.parameters,
          status,
          dateupdate: moment().format("YYYY-MM-DD"),
          datemembership,
          dateend,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Adhésion modifiée");
        } else setNotification("error", "Une erreur est survenue ici");
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error);
        setNotification("error", "Une erreur est survenue là");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>

            <div>
              <CustomSelect
                inputTitle={memberships.status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={market.marketAdminVisibility ? membershipStatusData : membershipStatusDataNoAdmin}
              />
            </div>
            {market.marketAdminVisibility &&
              <div>
                <DateInput
                  inputTitle={memberships.datemembership}
                  dateInput={datemembership}
                  handleDateInputChange={handleDatemembershipChange}
                />
              </div>}
            <div>
              <DateInput
                inputTitle={memberships.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Modifier
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default EditMarketMembershipStatusDialog;
